import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { Box, SxProps, Theme } from '@mui/material';

export type SocialPlatformIconSize = 'sm' | 'md' | 'lg';

const SIZE_PX: Record<SocialPlatformIconSize, number> = {
  sm: 16,
  md: 20,
  lg: 24,
};

type SocialPlatformIconProps = {
  platform: SocialPlatform;
  /** Icon scale preset (`sm` 16px, `md` 20px, `lg` 24px boxed). */
  size?: SocialPlatformIconSize;
  /** When true, applies the platform brand color. */
  colored?: boolean;
  sx?: SxProps<Theme>;
};

/**
 * Renders a social platform icon at a consistent size across pickers, selects, and cards.
 */
export function SocialPlatformIcon({
  platform,
  size = 'md',
  colored = true,
  sx,
}: SocialPlatformIconProps) {
  const px = SIZE_PX[size];

  if (size === 'lg') {
    return (
      <Box
        sx={[
          {
            width: px,
            height: px,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            '& > svg': { width: px, height: px, fontSize: px },
          },
          ...(sx !== undefined ? (Array.isArray(sx) ? sx : [sx]) : []),
        ]}
      >
        {platform.Icon({ colored })}
      </Box>
    );
  }

  return platform.Icon({
    colored,
    sx: [{ fontSize: px }, ...(sx !== undefined ? (Array.isArray(sx) ? sx : [sx]) : [])],
  });
}
